// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"a74bfb6e","405":"2349e4ba"}[chunkId] + ".chunk.css";
};